import Head from 'next/head'
import HomeContainer from '@/containers/HomeContainer'
import { wrapper } from '@/redux/store/configureStore'
import { getHeadersForSSR } from '@/utils'
import { isUserSignedInServerSide } from '@/utils/general/user'
import { COMMON_SEO_TITLE } from '@/constants/components/common'
import { faqSchema } from '@/constants/components'
import { getBBDJsonData } from '@/api/homepage'
import { getHostnameFromHeaders } from '@/utils/general/url'
import { BbdJson } from '@/types/home'
import { getInternalServerDns } from '@server/utils/internalDns'

const Home: React.FC<{ isSignedIn: boolean, uhpCookie: boolean | string,data: BbdJson[] }> = ({ isSignedIn, uhpCookie,data }) => {
    return (
        <>
            <Head>
                <title>Cleartrip: #1 Site for Booking Flights Tickets & Hotels Online - Get Best Travel Deals</title>
                <meta
                    content="Book cheap flight and air tickets at the lowest fares on Cleartrip. Find great deals on domestic and international flight bookings – all in one place."
                    name="description"
                />
                <link rel="canonical" href="https://www.cleartrip.com" />
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@type': 'WebSite',
                            name: 'Cleartrip',
                            url: 'https://www.cleartrip.com/',
                            sameAs: [
                                'https://www.instagram.com/cleartrip',
                                'https://www.facebook.com/cleartrip',
                                'https://www.linkedin.com/company/cleartrip/',
                                'https://twitter.com/cleartrip'
                            ]
                        })
                    }}
                />
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'https://schema.org/',
                            '@type': 'Organization',
                            url: 'https://www.cleartrip.com/',
                            logo: 'https://storage.googleapis.com/ct-seo-waytogo-assets/waytogo-staging/new_images/cleartrip.jpg'
                        })
                    }}
                />
                <script
                type='application/ld+json'
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(faqSchema),
                }}
                />
            </Head>
            <HomeContainer isSignedIn={isSignedIn}  uhpCookie={uhpCookie} data={data}/>
        </>
    )
}

export const getServerSideProps = wrapper.getServerSideProps(() => async context => {
    const { req } = context
    const cookies = req.cookies
    const signedIn = isUserSignedInServerSide(cookies)
    const uhpCookie = cookies['desktopUHP'] || 'false'
    const hostname = getHostnameFromHeaders(req.headers)
    const baseUrl = getInternalServerDns('cltpStatic', req.url, hostname)
    const data = await getBBDJsonData(baseUrl)
    //Add meta cookies to response.
    await getHeadersForSSR(context, {
        addUtmSourceInCookie: true
    })

    return {
        props: {
            isSignedIn: signedIn,
            uhpCookie: uhpCookie,
            data
        }
    }
})

export default Home
